export default __webpack_public_path__ + "static/blueHeroRight-1809729c30fd24095acc2213d65c1d4b.png";